import { render, staticRenderFns } from "./MenuPrincipal.vue?vue&type=template&id=b2ed454e&"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js&"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports